import { isEmpty } from '@/common/utils'
const isHttpSuccess = status => status >= 200 && status < 300

const sanitizeUri = value => value.replace(/([^:]\/)\/+/g, '$1')

const checkStatus = async response => {
  if (isHttpSuccess(response.status)) {
    return Promise.resolve(response)
  }

  const statusText = isEmpty(response.statusText)
    ? `Http Error ${response.status}`
    : response.statusText

  const error = new Error(statusText)
  error.response = response
  error.metaData = {
    response,
    statusText,
    httpError: true,
    url: response.url
  }

  try {
    error.metaData.body = await response.text()
  } catch (e) {

  }

  return Promise.reject(error)
}

const parseJSON = response => response.json()

export { checkStatus, parseJSON, isHttpSuccess, sanitizeUri }
